module.exports = __webpack_public_path__ + "img/lodygowice.965d2689.jpg";